import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Button } from 'antd';
import { SiteName, NavigationMenu, LogoutButton, HeaderBlock } from './styles';
import useAuth from '../../features/auth/hooks/useAuth';

const { Text } = Typography;

const Header = (): ReactElement => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleNavigateToUser = async () => {
    await navigate('/user');
  };

  const handleNavigateToHistory = async () => {
    await navigate('/history');
  };

  const handleNavigateToCallRequest = async () => {
    await navigate('/call-request');
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <HeaderBlock>
      <SiteName>
        <Text strong>架電システム</Text>
      </SiteName>
      <NavigationMenu>
        <Button type='text' onClick={handleNavigateToUser}>
          モニター設定
        </Button>
        <Button type='text' onClick={handleNavigateToHistory}>
          履歴
        </Button>
        <Button type='text' onClick={handleNavigateToCallRequest}>
          架電依頼
        </Button>
        <LogoutButton type='text' onClick={handleLogout}>
          ログアウト
        </LogoutButton>
      </NavigationMenu>
    </HeaderBlock>
  );
};

export default Header;
